<audio #audio [src]="src" [controls]="controls" [preload]="preload" [autoplay]="autoPlay">
    Your browser does not support the <code>audio</code> element.
</audio>